import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteDataProvider } from "./context/SiteDataContext";
import LandingPage from "./pages/LandingPage";
import AdminPanel from "./pages/AdminPanel";
import ResetPassword from "./pages/ResetPassword";
import DashboardLayout from "./components/dashboard/DashboardLayout";
import DashboardHome from "./components/dashboard/DashboardHome";
import BuyNow from "./components/dashboard/BuyNow";
import MyProfile from "./components/dashboard/MyProfile";
import MyOrders from "./components/dashboard/MyOrders";
import Airdrop from "./components/dashboard/Airdrop";
import MyTransactions, { MyReferrals } from "./components/dashboard/MyTransactions";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-[#060d06] flex items-center justify-center text-yellow-400">Loading...</div>;
  if (!user) return <Navigate to="/" />;
  return children;
};

const DashboardRoute = ({ children }) => (
  <ProtectedRoute>
    <DashboardLayout>{children}</DashboardLayout>
  </ProtectedRoute>
);

function App() {
  return (
    <AuthProvider>
      <SiteDataProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/dashboard" element={<DashboardRoute><DashboardHome /></DashboardRoute>} />
              <Route path="/dashboard/buynow" element={<DashboardRoute><BuyNow /></DashboardRoute>} />
              <Route path="/dashboard/profile" element={<DashboardRoute><MyProfile /></DashboardRoute>} />
              <Route path="/dashboard/orders" element={<DashboardRoute><MyOrders /></DashboardRoute>} />
              <Route path="/dashboard/airdrop" element={<DashboardRoute><Airdrop /></DashboardRoute>} />
              <Route path="/dashboard/transactions" element={<DashboardRoute><MyTransactions /></DashboardRoute>} />
              <Route path="/dashboard/referrals" element={<DashboardRoute><MyReferrals /></DashboardRoute>} />
            </Routes>
          </BrowserRouter>
        </div>
      </SiteDataProvider>
    </AuthProvider>
  );
}

export default App;
